import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable, catchError, concatMap, map, of } from "rxjs";
import { ApiService } from "src/app/core/service/api.service";
import { InvisibleRecaptchaService } from "src/app/core/service/invisible-recaptcha.service";
import { UploadScreenInfo } from "src/app/shared/components/atoms/file-upload-component/model/file-uplaod.interface";
import { getUploadFile } from "src/app/state/reducers/upload-file.reducer";
import { UploadFileContactInformation } from "../../contact-information/model/potential-customer";
import { getPremisesPhoto } from "src/app/state/reducers/contact-information.reducer";
import { resetFile } from "src/app/state/actions/upload-file.actions";
import { resetPremisesPhotos } from "src/app/state/actions/contact-information.actions";

export interface InfoClienteDocumentUpload {
  identificationNumber?: string;
  customerId?: number;
  requestId?: number;
};
export type UploadFileData = {
  fileBase64?: string;
  fileData: {
    filename: string;
    contentType: string;
  };
};

export type UploadFileBody = UploadFileData & {
  customerData: {
    identificationNumber?: string;
    requestId?: number;
    customerId?: number;
    documentTypeId?: number;
  };
  captcha?: string;
};

export type FileToSaveData = UploadFileData & { documentTypeId: number };

export const fileToBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = (error) => reject(error);
  });

@Injectable({
  providedIn: "root",
})
export class RegisterCompleteService {
  action: string = "register_complete";
  constructor(
    public apiSrv: ApiService,
    private readonly captchaSrv: InvisibleRecaptchaService,
    private readonly store: Store
  ) {}

  uploadFile(data: UploadFileBody): Observable<any> {
    let body = data;
    return this.captchaSrv
      .getCaptcha(this.action)
      .pipe(catchError(() => of('Error consiguiendo el captcha')))
      .pipe(
        map((token) => ({
          ...body,
          captcha: token,
        }))
      )
      .pipe(
        concatMap((data) =>
          this.apiSrv.post("api/upload-file", data, {
            showError: true,
            ngxSpinner: false,
          })
        )
      );
  }

  saveInfo(data: any): Observable<any> {
    let body = data;
    return this.captchaSrv
      .getCaptcha(this.action)
      .pipe(catchError(() => of('Error consiguiendo el captcha')))
      .pipe(
        map((token) => ({
          ...body,
          captcha: token,
        }))
      )
      .pipe(
        concatMap((data) =>
          this.apiSrv.post("api/create-customer-request", data, {
            showError: true,
          })
        )
      );
  }
  
  organizeFiles(data: FileToSaveData[], infoCliente: InfoClienteDocumentUpload): Observable<any> {
    let body = { fileData: data, ...infoCliente, captcha: ''};
    return this.captchaSrv
      .getCaptcha(this.action)
      .pipe(catchError(() => of('Error consiguiendo el captcha')))
      .pipe(
        map((token) => ({
          ...body,
          captcha: token,
        }))
      )
      .pipe(
        concatMap((data) =>
          this.apiSrv.post("api/organize-files-customer", data, {
            showError: true,
            ngxSpinner: true,
          })
        )
      );
  }

  getUploadFile(): Observable<UploadScreenInfo> {
    let resp: UploadScreenInfo = {
      fileDoc: [],
      dniValidationRequired: false,
    };
    this.store.select(getUploadFile).subscribe((data) => {
      resp = data;
    });
    return of(resp);
  }

  getPremisesPhoto(): Observable<UploadFileContactInformation> {
    let resp: UploadFileContactInformation = {};
    this.store.select(getPremisesPhoto).subscribe((data) => {
      resp = data;
    });
    return of(resp);
  }

  deleteStore() {
    this.store.dispatch(resetFile());
    this.store.dispatch(resetPremisesPhotos());
  }

  deleteSessionStore() {
    sessionStorage.clear();
  }
}
